(function () {
  const TARGET_FORM_ID = 'forms-root-933725';

  function createLabel(text, required = false) {
    const el = document.createElement('div');
    el.className = 'custom-field-title';
    el.innerHTML = required
      ? `${text} <span class="required-star">*</span>`
      : text;
    return el;
  }

  function createFieldBlock(labelText, nodes, required = false, extraClass = '') {
    const block = document.createElement('div');
    block.className = `custom-field-block ${extraClass}`.trim();

    block.appendChild(createLabel(labelText, required));

    nodes.forEach((node) => {
      if (node) block.appendChild(node);
    });

    return block;
  }
    function relocateLooseErrors(form) {
    const looseOutputs = Array.from(form.children).filter(
        (el) => el.tagName === 'OUTPUT'
    );

    if (!looseOutputs.length) return;

    const firstNameBlock = form.querySelector('.custom-first-name-block');
    const emailBlock = form.querySelector('.custom-email-block');
    const messageBlock = form.querySelector('.custom-message-block');

    looseOutputs.forEach((output) => {
        const text = output.textContent.trim().toLowerCase();

        if (text.includes('first name') && firstNameBlock && !firstNameBlock.contains(output)) {
        firstNameBlock.appendChild(output);
        return;
        }

        if (text.includes('email') && emailBlock && !emailBlock.contains(output)) {
        emailBlock.appendChild(output);
        return;
        }

        if (text.includes('field is required') && messageBlock && !messageBlock.contains(output)) {
        messageBlock.appendChild(output);
        }
    });
    }

    function translateErrorTexts(form) {
  const alerts = form.querySelectorAll('output[role="alert"]');

  alerts.forEach((output) => {
    const text = output.textContent.trim();
    if (!text) return;

    output.textContent = 'Nõutud väli';
  });
}



function initSubjectPlaceholder(root) {
  const subjectText = root.querySelector(
    'button[aria-controls*="custom#mille_kohta_kirjutad"] ._selectToggleText_12thd_25'
  );

  if (!subjectText) return;

  if (!subjectText.textContent.trim()) {
    subjectText.textContent = 'Vali teema:';
  }
}
function attachInternalErrorWatcher(root, form) {
  if (root.__customErrorWatcherAttached) return;

  let timer = null;

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      relocateLooseErrors(form);
      translateErrorTexts(form);
      initSubjectPlaceholder(root);
    }, 30);
  };

  const observer = new MutationObserver(() => {
    schedule();
  });

  observer.observe(form, {
    childList: true,
    subtree: false
  });

  form.addEventListener('submit', schedule, true);
  form.addEventListener('change', schedule, true);
  form.addEventListener('blur', schedule, true);

  root.__customErrorWatcherAttached = true;
}
function forcePhonePlaceholderOnly(root) {
  const phoneInput = root.querySelector('#phone_number');
  if (!phoneInput) return;

  const normalize = () => {
    const val = (phoneInput.value || '').replace(/\s+/g, '').trim();

    // only clear the auto-added country code, not real user input
    if (val === '+372' || val === '372') {
      phoneInput.value = '';
    }

    phoneInput.placeholder = '+372 5xxx xxxx';
  };

  normalize();

  if (!phoneInput.dataset.placeholderOnlyBound) {
    phoneInput.addEventListener('focus', normalize);
    phoneInput.addEventListener('blur', normalize);
    phoneInput.addEventListener('change', normalize);
    phoneInput.addEventListener('input', () => {
      const val = (phoneInput.value || '').replace(/\s+/g, '').trim();
      if (val === '+372' || val === '372') {
        phoneInput.value = '';
      }
    });

    phoneInput.dataset.placeholderOnlyBound = '1';
  }
}


  function initForm(embed) {
    if (!embed || !embed.shadowRoot) return;

    const root = embed.shadowRoot;
    const form = root.querySelector('form');
    if (!form) return;

    const styleAlreadyAdded = root.querySelector('#custom-form-933725-style');

    if (!styleAlreadyAdded) {
    const style = document.createElement('style');
    style.id = 'custom-form-933725-style';
    style.textContent = `
        :host {
        --custom-border: #d8d7cf;
        --custom-text: #2f2f2b;
        --custom-muted: #b9b8b0;
        --custom-bg: #ffffff;
        --custom-btn: #87952a;
        --custom-btn-text: #ffffff;
      }

      ._formContainer_1q1d2_30 {
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        max-width: 560px !important;
        margin: 0 auto !important;
      }

      ._gridItemContent_1q1d2_257 {
        width: 100%;
      }

      ._formHeader_cit2d_24 {
        text-align: center !important;
        margin-bottom: 28px !important;
      }

      ._textHeading_2aowh_35 {
        font-size: 28px !important;
        line-height: 1.2 !important;
        font-weight: 700 !important;
        color: var(--custom-text) !important;
        margin: 0 0 8px !important;
      }

      ._textBody_2aowh_10 {
        color: #9d9c94 !important;
        font-size: 15px !important;
      }

      form {
        background: var(--custom-bg);
        border-radius: 18px;
        padding: 24px !important;
        display: flex;
        flex-direction: column;
        gap: 18px;
        box-sizing: border-box;
      }

      .custom-two-cols {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }

      @media (max-width: 768px) {
        form {
          padding: 18px !important;
        }

        .custom-two-cols {
          grid-template-columns: 1fr;
        }
      }
    @media (max-width: 468px) {
    form{
        min-width: 350px !important;
    }
    }
    @media (max-width: 350px) {
    form{
        min-width: 250px !important;
    }
    }

      .custom-field-block {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .custom-field-title {
        font-size: 14px;
        font-weight: 700;
        color: var(--custom-text);
        line-height: 1.3;
        text-align: left;
      }

      .required-star {
        color: #98a336;
        font-weight: 700;
      }

      /* peida Shopify floating labelid */
      label._formInputFieldLabel_1mxsl_38,
      ._label_12thd_10 {
        display: none !important;
      }

      /* üldine field spacing */
      ._formFieldContainer_1mxsl_5,
      ._formPhoneInputContainer_piv1u_6,
      ._selectContainer_12thd_6 {
        margin: 0 !important;
      }

      /* telefoni country selector peida */
      .phone-country-selector {
        display: none !important;
      }

      ._formPhoneInputContainer_piv1u_6 {
        display: block !important;
      }

      ._formFieldContainer_1mxsl_5 input,
      ._formPhoneInputField_piv1u_17,
      ._formFieldContainer_1mxsl_5 textarea,
      ._selectToggle_12thd_25 {
        width: 100% !important;
        box-sizing: border-box !important;
        border: 2px solid var(--custom-border) !important;
        border-radius: 10px !important;
        background: #fff !important;
        color: var(--custom-text) !important;
        font-size: 15px !important;
        box-shadow: none !important;
      }

      ._formFieldContainer_1mxsl_5 input,
      ._formPhoneInputField_piv1u_17,
      ._selectToggle_12thd_25 {
        height: 46px !important;
        min-height: 46px !important;
        padding: 0 14px !important;
      }

      ._formPhoneInputField_piv1u_17 {
        padding-left: 14px !important;
      }

      ._formFieldContainer_1mxsl_5 textarea {
        min-height: 90px !important;
        padding: 14px !important;
        resize: vertical !important;
      }

      input::placeholder,
      textarea::placeholder {
        color: var(--custom-muted) !important;
        opacity: 1 !important;
      }

      ._selectToggleText_12thd_25 {
        color: var(--custom-text) !important;
      }

      ._formSubmitButton_cit2d_96 {
        margin-top: 2px !important;
        border-radius: 10px !important;
        background: var(--custom-btn) !important;
        color: var(--custom-btn-text) !important;
        border: 0 !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        box-shadow: none !important;
      }

      ._formDisclaimer_cit2d_38 {
        text-align: center !important;
        margin-top: 14px !important;
        color: #9d9c94 !important;
        font-size: 14px !important;
      }

      ._formDisclaimer_cit2d_38 a {
        color: var(--custom-btn) !important;
        text-decoration: none !important;
        font-weight: 700 !important;
      }

      ._formError_1mxsl_21,
      ._error_1o4ef_1 {
        margin-top: 4px !important;
        text-align: left !important;
        font-size: 12px !important;
      }

            /* message field fix */
      textarea[name="custom#kuidas_saame_aidata"] {
        display: block !important;
        width: 100% !important;
        min-height: 90px !important;
        height: 90px !important;
        margin: 0 !important;
        padding: 16px 14px !important;
        line-height: 1.45 !important;
        border: 2px solid var(--custom-border) !important;
        border-radius: 10px !important;
        background: #fff !important;
        box-sizing: border-box !important;
        box-shadow: none !important;
        outline: none !important;
        resize: vertical !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      textarea[name="custom#kuidas_saame_aidata"]::placeholder {
        color: var(--custom-muted) !important;
        opacity: 1 !important;
      }

      textarea[name="custom#kuidas_saame_aidata"] + label {
        display: none !important;
      }

      .custom-message-block ._formFieldContainer_1mxsl_5 {
        overflow: visible !important;
      }

      .custom-message-block {
        gap: 10px !important;
      }

      /* tighter overall spacing to match mockup */
      form {
        gap: 16px !important;
      }

      ._formHeader_cit2d_24 {
        margin-bottom: 24px !important;
      }

      /* phone field vertical alignment */
      ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
        margin-top: 0 !important;
      }
    ._formFieldContainer_1mxsl_5:has(textarea)::before{
        height: unset !important;
    }
        .custom-field-block {
  gap: 6px !important;
}

.custom-two-cols {
  row-gap: 6px !important;
}


._formPhoneInputContainer_piv1u_6 > output._formError_1mxsl_21,
._selectContainer_12thd_6 > output._error_1o4ef_1 {
  display: block !important;
  margin: 10px 0 0 !important;
  padding: 0 !important;
  line-height: 1.2 !important;
  font-size: 12px !important;
}

.custom-email-block,
.custom-subject-block,
.custom-message-block,
.custom-first-name-block {
  margin-bottom: 2px !important;

  
}
  ._inline_1q1d2_47{
  height:unset !important;
  padding-block: 40px;
  }
    `;
    root.appendChild(style);
    }



    const firstNameField = root.querySelector('#first_name')?.closest('._formFieldContainer_1mxsl_5');
    const firstNameError = firstNameField?.nextElementSibling?.matches('output') ? firstNameField.nextElementSibling : null;

    const phoneWrap = root.querySelector('#phone_number')?.closest('._formPhoneInputContainer_piv1u_6');

    const emailField = root.querySelector('#email')?.closest('._formFieldContainer_1mxsl_5');
    const emailError = emailField?.nextElementSibling?.matches('output') ? emailField.nextElementSibling : null;

    const subjectButton = root.querySelector('button[aria-controls*="custom#mille_kohta_kirjutad"]');
    const subjectWrap = subjectButton?.closest('._selectContainer_12thd_6');

    const textareaField = root.querySelector('textarea[name="custom#kuidas_saame_aidata"]')?.closest('._formFieldContainer_1mxsl_5');
    const textareaError = textareaField?.nextElementSibling?.matches('output') ? textareaField.nextElementSibling : null;

    const submitBtn = root.querySelector('[data-testid="btn-form-submit"]');
    if (!submitBtn) return;

    // placeholderid
    const firstNameInput = root.querySelector('#first_name');
    const phoneInput = root.querySelector('#phone_number');
    const emailInput = root.querySelector('#email');
    const textarea = root.querySelector('textarea[name="custom#kuidas_saame_aidata"]');

    if (firstNameInput) firstNameInput.placeholder = 'Sinu nimi';
    if (phoneInput) phoneInput.placeholder = '+372 5xxx xxxx';
    if (emailInput) emailInput.placeholder = 'nimi@email.ee';
    if (textarea) {
        textarea.placeholder = 'Kirjelda oma küsimust, projekti või vajadust...';
        textarea.rows = 4;
        }

    // vali teema... teksti dropdownile
    if (subjectButton) {
      const textHolder = subjectButton.querySelector('span._selectToggleText_12thd_25');
      if (textHolder && !textHolder.textContent.trim()) {
        textHolder.textContent = 'Vali teema: ';
      }
    }

    // Nimi + Telefon ritta
    if (firstNameField && phoneWrap && !form.querySelector('.custom-two-cols')) {
      const row = document.createElement('div');
      row.className = 'custom-two-cols';

      const firstNameBlock = createFieldBlock('Nimi', [firstNameField, firstNameError], true, 'custom-first-name-block');
      const phoneBlock = createFieldBlock('Telefon', [phoneWrap], false);

      row.appendChild(firstNameBlock);
      row.appendChild(phoneBlock);

      form.insertBefore(row, form.firstChild);
    }

    // E-post
    if (emailField && !form.querySelector('.custom-email-block')) {
      const emailBlock = createFieldBlock('E-post', [emailField, emailError], true, 'custom-email-block');
      form.insertBefore(emailBlock, submitBtn);
    }

    // Mille kohta kirjutad?
    if (subjectWrap && !form.querySelector('.custom-subject-block')) {
      const subjectBlock = createFieldBlock('Mille kohta kirjutad?', [subjectWrap], false, 'custom-subject-block');
      form.insertBefore(subjectBlock, submitBtn);
    }

    // Kuidas saame aidata?
    if (textareaField && !form.querySelector('.custom-message-block')) {
      const textareaBlock = createFieldBlock('Kuidas saame aidata?', [textareaField, textareaError], true, 'custom-message-block');
      form.insertBefore(textareaBlock, submitBtn);
    }

attachInternalErrorWatcher(root, form);
relocateLooseErrors(form);
translateErrorTexts(form);
forcePhonePlaceholderOnly(root);
initSubjectPlaceholder(root);
  }

  function initTargetFormOnly() {
    const wrapper = document.querySelector(`[data-forms-id="${TARGET_FORM_ID}"]`);
    if (!wrapper) return;

    const embed = wrapper.querySelector('shopify-forms-embed');
    if (!embed) return;

    initForm(embed);
  }

  const observer = new MutationObserver(() => {
    initTargetFormOnly();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', initTargetFormOnly);
  window.addEventListener('load', initTargetFormOnly);
})();